import * as Msal from 'msal'

export default class AuthService {
  constructor(msalConfig) {

    this.msalApp = new Msal.UserAgentApplication(msalConfig)

    this.msalApp.handleRedirectCallback((error, response) => {
      // if error is not null, something went wrong
      // if not, response is a successful login response
      // TODO: need to handle the error gracefully
      localStorage.removeItem("signInPending");
      // if (response.idToken)
      // {
      //   console.log('handleRedirectCallback called with idToken present');
      // } else {
      //   console.log('handleRedirectCallback called with idToken missing!');
      // }

      if (error)
      {
        console.log('handleRedirectCallback called but had ERROR:');
        console.log(error);
      }
    });
  }


  signIn() {
    var loginRequest = {
      scopes: null
    };

    let signInPending = localStorage.getItem("signInPending");
    if (!signInPending) 
    {
      localStorage.setItem("signInPending", '1');
      this.msalApp.loginRedirect(loginRequest);
    }
    // else {
    //   console.log('signIn Pending');
    // }
  }

  // Refresh user's IdToken
  async refreshIdToken() {
    // For the renewal of IdToken to work we must have only 1 scope in the tokenRequest, which is the clientId
    // https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/752

    var tokenRequest = { scopes: [this.msalApp.clientId] };

    return await this.msalApp
      .acquireTokenSilent(tokenRequest)
      .then((response) => {
        return response.idToken.rawIdToken;
      })
      .catch((error) => {
        console.log("Error from acquireTokenSilent. Invoking signIn")
        this.signIn();
      });
  }

  async getIdToken() {
    //per. Microsoft MSAL v1: Use this function to obtain a token before every call to the API / resource provider
    let token = await this.refreshIdToken();
    return token;
  }

  // signout the user
  signOut() {
    // Removes all sessions, need to call AAD endpoint to do full logout
    this.msalApp.logout();
  }

  getUser() {
    return this.msalApp.getAccount();
  }

  isAuthenticated() {
    var user = this.getUser();
    if (user != null) {
      var now = new Date();
      var tokenExpiration = user.idTokenClaims.exp;
      var secondsSinceEpoch = Math.round(now.getTime() / 1000);
      var isValid = tokenExpiration > (secondsSinceEpoch + 5);

      return isValid;
    }

    return false;
  }

}
